import basePageFields from '@fragments/pages/basePageFields';

import CenterSummaryFragment from '@fragments/summaries/CenterSummaryFragment';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import PersonSummaryFragment from '@fragments/summaries/PersonSummaryFragment';

export default gql`
    fragment PodcastsLandingFragment on PodcastsLanding {
        ${basePageFields}
        podcasts {
            ... on Podcast {
                contributors {
                    ...PersonSummaryFragment
                }
                dek
                hero {
                    image {
                        ...ImageSummaryFragment
                    }
                }
                path
                parent {
                    value {
                        ...CenterSummaryFragment
                    }
                }
                title
            }
        }
    }

    ${CenterSummaryFragment}
    ${ImageSummaryFragment}
    ${PersonSummaryFragment}
`;
